import React from "react";
import { Stack } from "@mui/material";
import ShowPageProvider from "../../../provider/ShowPageProvider";
import { color } from "../../../config";
import LoadingProvider from "../../../provider/LoadingProvider";
import QuestionsProvider from "../../../provider/QuestionProvider";
import SnackbarProvider from "../../../provider/SnackbarProvider";
import CustomSnackbar from "./CustomSnackbar";
import MyDialog from "../../components/MyDialog";
export const API_URL = process.env.REACT_APP_API_URL;

type Props = {
  children: React.ReactNode;
};

export default function BackGround(props: Props) {
  const { children } = props;

  // const [login, setLogin] = useState(false);

  // async function handleSignIn(email: string, password: string) {
  //   if (email && password) {
  //     const response = await fetch(`${API_URL}/login`, {
  //       method: "POST",
  //       body: JSON.stringify({
  //         username: email,
  //         password,
  //       }),
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.statusCode !== 200) {
  //           throw new Error("Login failed");
  //         } else {
  //           setLogin(true);
  //           return data;
  //         }
  //       })
  //       .then((data) => {
  //         setApiKey(data.data);
  //         return true;
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         return false;
  //       });
  //   }
  // }

  // const [userData, setUserData] = useState({
  //   name: "",
  //   email: "",
  //   id: "",
  //   token: "",
  // });

  // async function updateUserData() {
  //   const newUserData = await getUserData();
  //   console.log(newUserData);
  //   setUserData(newUserData);
  // }

  // useEffect(() => {
  //   updateUserData();
  // }, []);

  // if (!login) {
  //   return (
  //     <Stack
  //       direction={"column"}
  //       alignItems={"center"}
  //       height={"100%"}
  //       minHeight={"92vh"}
  //       width={"calc(100vw - 40px)"}
  //       padding={2}
  //       sx={{
  //         backgroundColor: color.background,
  //       }}
  //     >
  //       <LoginForm handleSignIn={handleSignIn} />
  //     </Stack>
  //   );
  // }
  return (
    <LoadingProvider>
      <SnackbarProvider>
        <ShowPageProvider>
          <QuestionsProvider>
            <Stack
              direction={"column"}
              flex={1}
              // alignItems={"center"}
              height={"100vh"}
              // minHeight={"92vh"}
              // width={"calc(100vw - 40px)"}
              padding={2}
              sx={{
                backgroundColor: color.background,
                overflowY: "auto",
              }}
            >
              {children}
              <CustomSnackbar />
              <MyDialog />
            </Stack>
          </QuestionsProvider>
        </ShowPageProvider>
      </SnackbarProvider>
    </LoadingProvider>
  );
}
